import { axiosBaseQuery } from '@client';
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { ProformaSummaryResponse } from '@state/types/ProformaSummaryResponse';

export const proformaV2Api = createApi({
  baseQuery: axiosBaseQuery({ baseUrl: 'secured/v2/proforma' }),
  reducerPath: 'proforma-v2-api',
  tagTypes: ['PROFORMA_V2'],
  endpoints: (build) => ({
    fetchProformaSummary: build.query<
      ProformaSummaryResponse,
      { proformaId: number }
    >({
      query: ({ proformaId }) => ({
        url: `/${proformaId}/summary`,
        method: 'GET'
      }),
      providesTags: (_res, _err, { proformaId }) => [
        { type: 'PROFORMA_V2', id: proformaId }
      ]
    })
  })
});

export const { useFetchProformaSummaryQuery } = proformaV2Api;

export type StateWithProformaV2Api = {
  [proformaV2Api.reducerPath]: ReturnType<typeof proformaV2Api.reducer>;
};
